import Container from '@components/global/Container';
import {
  LinkCardGridSliceData,
  PageType,
} from '@adapters/prismic/types/slices';
import LinkCard from './LinkCard';

import styles from './LinkCardGrid.module.scss';

export interface LinkCardGridProps {
  items: LinkCardGridSliceData[];
  trackPromos?: boolean;
  pageType?: PageType;
  sliceIndex?: number;
}

const LinkCardGrid = ({
  items,
  trackPromos,
  pageType,
  sliceIndex,
}: LinkCardGridProps) => (
  <Container>
    <ul className={styles.linkCardGridContainer}>
      {items?.map(({ card_image, sub_text, button_text, link_url }, i) => (
        <LinkCard
          key={sub_text}
          image={card_image}
          text={sub_text}
          buttonText={button_text}
          link={link_url}
          trackPromos={trackPromos}
          pageType={pageType}
          positionWithinSlice={i}
          sliceIndex={sliceIndex}
        />
      ))}
    </ul>
  </Container>
);

export default LinkCardGrid;
